/** Map legacy catalog codes (RFC-0015 import) → UI canonical values. */
const LEGACY_WORK_TYPE = {
    product: 'OKR-C',
    tech: 'OKR-A',
    run: 'RUN',
};
export function normalizeWorkType(code) {
    const t = String(code ?? '').trim();
    if (!t)
        return '';
    return LEGACY_WORK_TYPE[t] ?? LEGACY_WORK_TYPE[t.toLowerCase()] ?? t;
}
export function displayWorkType(code) {
    const n = normalizeWorkType(code);
    return n || '—';
}
export function displayPriority(code) {
    const p = String(code ?? '').trim();
    return p || '—';
}
